import { TEXTOS } from '../../lib/glossario'
import { IconeMenu, IconeSeta } from '../Icones'
import { ID_DO_MENU } from './BarraLateral'
import { MenuDoUsuario } from './MenuDoUsuario'

interface Props {
  /** Nome da tela aberta, vindo do registro de navegação. Ausente fora do menu. */
  titulo?: string
  /** O grupo do menu em que a tela mora ("Mudanças (GMUD)", "Fiscalização do mês"…). */
  grupo?: string
  /** A frase de uma linha, para leigo, que o registro escreve para cada tela. Vira dica da trilha. */
  resumo?: string
  gavetaAberta: boolean
  aoAlternarGaveta: () => void
}

/**
 * A faixa de cima: onde a pessoa está e quem está logado.
 *
 * Uma linha só, com a trilha "grupo › tela". Antes eram três linhas — sigla do órgão, nome do
 * sistema com o da tela, e o resumo — e as três repetiam o que o título e a descrição da própria
 * tela dizem logo abaixo. A marca do sistema mora no topo do menu lateral; aqui ela só aparece em
 * tela pequena, onde o menu é gaveta e está fechado.
 *
 * A trilha é um parágrafo e não um `<h1>` de propósito. Cada tela já tem o seu, e um segundo
 * título de nível 1 na moldura faria toda página ter dois — para quem navega por cabeçalhos, isso
 * é ter de escolher entre dois começos em toda tela do sistema.
 *
 * O filete laranja é o acento institucional em preenchimento, nunca em texto: #f85808 sobre
 * branco dá ~3,4:1 e não passa em AA como letra. Como faixa, não há texto em cima dele.
 *
 * @param props título e grupo da tela, estado da gaveta e o comando de abri-la
 * @returns a barra superior
 */
export function BarraSuperior({ titulo, grupo, resumo, gavetaAberta, aoAlternarGaveta }: Props) {
  return (
    <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/85">
      <div aria-hidden="true" className="h-1 bg-laranja-500" />
      <div className="flex h-14 items-center gap-3 px-4 lg:px-8">
        <button
          type="button"
          onClick={aoAlternarGaveta}
          aria-expanded={gavetaAberta}
          aria-controls={ID_DO_MENU}
          aria-label={gavetaAberta ? 'Fechar o menu' : 'Abrir o menu'}
          className="-ml-1 rounded-lg p-2 text-slate-600 hover:bg-slate-100 hover:text-slate-900 lg:hidden"
        >
          <IconeMenu />
        </button>

        {/* Em tela pequena o menu é gaveta e a marca do sistema some com ele: ela volta aqui. */}
        <img src="/img/brasao-niteroi.svg" alt="" className="h-7 w-auto shrink-0 lg:hidden" />

        <p title={resumo} className="flex min-w-0 items-center gap-1.5 text-sm">
          <span className="shrink-0 font-bold text-niteroi-700 lg:hidden">{TEXTOS.nomeDoSistema}</span>
          {grupo && <span className="hidden truncate text-slate-500 lg:inline">{grupo}</span>}
          {titulo && (
            <>
              <IconeSeta className="hidden h-3.5 w-3.5 shrink-0 text-slate-400 sm:inline" />
              <span className="hidden truncate font-medium text-slate-900 sm:inline">{titulo}</span>
            </>
          )}
        </p>

        <div className="ml-auto">
          <MenuDoUsuario />
        </div>
      </div>
    </header>
  )
}
